<script>
import { ref, h, watch } from 'vue';

function loadIconSvg(name) {
  return import(
    /* webpackMode: "lazy-once" */
    /* webpackChunkName: "icon-[request]" */
    `../../assets/icons/${name}.svg`
  );
}

export default {
  props: { name: String },

  setup(props, { attrs }) {
    const svgElement = ref(null);
    let loadToken = 0;

    const loadIcon = async (name) => {
      if (!name) {
        svgElement.value = null;
        return;
      }
      const token = ++loadToken;
      try {
        const module = await loadIconSvg(name);
        if (token !== loadToken) return;
        const svgContent = module.default;
        const parser = new DOMParser();
        svgElement.value = parser.parseFromString(
          svgContent,
          'image/svg+xml'
        ).documentElement;
      } catch (_err) {
        if (token !== loadToken) return;
        svgElement.value = null;
      }
    };

    watch(
      () => props.name,
      (name) => {
        loadIcon(name);
      },
      { immediate: true }
    );

    function convertElementToVNode(node, isRoot = false) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const children = Array.from(node.childNodes).map((child) =>
          convertElementToVNode(child, false)
        );
        const vnodeData = {
          ...Array.from(node.attributes).reduce((acc, attr) => {
            if (attr.name === 'fill') {
              const classes = [props.class, attrs.class].filter(Boolean).join(' ');
              if (classes && classes.includes('fill-')) {
                return acc;
              }
            }
            acc[attr.name] = attr.value;
            return acc;
          }, {}),
          ns: 'http://www.w3.org/2000/svg',
        };

        if (isRoot) {
          const classes = [props.class, attrs.class].filter(Boolean).join(' ');
          if (classes) {
            vnodeData.class = classes;
          }
        }

        return h(node.tagName, vnodeData, children);
      } else if (node.nodeType === Node.TEXT_NODE) {
        return node.nodeValue;
      }
      return null;
    }

    return () => {
      if (svgElement.value) {
        return h('span', { translate: 'no', class: 'inline-flex items-center justify-center shrink-0 [&>svg]:block [&>svg]:shrink-0' }, [
          convertElementToVNode(svgElement.value, true),
        ]);
      }
      return null;
    };
  },
};
</script>
